<template>
  <tbody>
  <tr :class="['clickable', {disabled: !entity.provided, updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Série a epizoda' | translate">
      {{ entity.season_and_episode_number }}
    </td>
    <td :data-th="'Věkové omezení' | translate">
      {{ entity.maturity_rating }}
    </td>
    <td :data-th="'Poskytovatel videa' | translate">
      {{ entity.vod_provider_name }}
    </td>
    <td :data-th="'Balíčky' | translate">
      {{ entity.vod_packages }}
    </td>
    <td :data-th="'Stav zpracování na zdroji' | translate">
      {{ getSourceStateText(entity.source_state) }}
    </td>
    <td :data-th="'Stav lokálního zpracování' | translate">
      {{ getLocalStateText(entity.local_state) }}
    </td>
    <td :data-th="'Délka' | translate">
      {{ $_formatMinutesToString(entity.duration_seconds/60) }}
    </td>
    <td :data-th="'Poskytováno od' | translate">
      {{ isSerie && groupBySeries ? '' : $_date_format(entity.provided_from) }}
    </td>
    <td :data-th="'Poskytováno do' | translate">
      {{ isSerie && groupBySeries ? '' : $_date_format(entity.provided_to) }}
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";
import vodVideo from "../vodVideos/mixins/vodVideo";

export default {
  name: "VodEpisodesRow",
  mixins: [rowActions, vodVideo],
  props: {
    entity: Object,
  },
  methods: {
    goToDetail(e, id) {
        this.$router.push({name: 'vodVideosDetail', params: {id: id}})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodEpisodes/VodEpisodesRow.vue